import { Navigate, useLocation } from 'react-router-dom';

/**
 * Client-side forwarding stub for the legacy paths in `redirects`
 * (web/src/routes.tsx). `replace` keeps the stale URL out of the history stack
 * so Back doesn't bounce the visitor straight back into the redirect, and the
 * query string + hash are carried over so campaign/UTM params still reach the
 * destination's pageview.
 */
export function RedirectRoute({ to }: { to: string }) {
  const { search, hash } = useLocation();

  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
